import { useMemo } from "react";
import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import { formatBucketLabel } from "../../services/services.formatters";

interface CaTrendPoint {
  bucket: string;
  gross: number;
  gain: number;
}

export function useCaTrendChartConfig(trend: CaTrendPoint[]) {
  return useMemo(
    () => ({
      type: "line" as const,
      data: {
        labels: trend.map((point) => formatBucketLabel(point.bucket)),
        datasets: [
          {
            label: "CA Brut",
            data: trend.map((point) => point.gross),
            borderColor: CHART_COLORS.muted,
            backgroundColor: `${CHART_COLORS.muted}22`,
            fill: true,
            tension: 0.3,
          },
          {
            label: "Gain",
            data: trend.map((point) => point.gain),
            borderColor: CHART_COLORS.primary,
            backgroundColor: `${CHART_COLORS.primary}22`,
            fill: true,
            tension: 0.3,
          },
        ],
      },
      options: {
        plugins: { legend: { position: "top" as const, labels: { font: { size: 11 } } } },
        scales: {
          x: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { display: false },
          },
          y: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { color: CHART_COLORS.grid },
            beginAtZero: true,
          },
        },
      },
    }),
    [trend],
  );
}
